import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { SpaceOperationsFragment$key } from '@confluence/entity-operations/entry-points/SpaceOperationsFragmentKey.ts';

export const BlogTree: LoadableType<{
	spaceKey: string;
	pageTreeFinishedLoading: boolean;
	spaceOperationsRef?: SpaceOperationsFragment$key;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BlogTree" */ '../src/BlogTree.tsx')).BlogTree,
});
